import copyButtonTpl from '../templates/copy_button.directive.html';

function CopyButtonController($timeout) {
  const vm = this;

  vm.buttonText = 'COPY';
  vm.copySuccess = copySuccess;

  function copySuccess() {
    vm.buttonText = 'COPIED';

    $timeout(() => {
      vm.buttonText = 'COPY';
    }, 2000);
  }

  return vm;
}

CopyButtonController.$inject = ['$timeout'];

export default function copyButton() {
  return {
    restrict: 'E',
    template: copyButtonTpl,
    controller: CopyButtonController,
    controllerAs: 'copyVm',
    bindToController: true,
    scope: {
      textToCopy: '='
    }
  };
}
